import React from 'react';
import cn from 'classnames';

import s from './DescriptionCard.module.css';

function DescriptionCard(props) {
  const { description, smallDescr } = props;
  return (
    <div className={s.wrapper}>
      <img className={s.imageWrapper} src={`${description['image_url']}`} />
      <div className={s.title}>{description.title}</div>
      <div
        className={cn(s.description, { [s.smallDescr]: smallDescr })}
        dangerouslySetInnerHTML={{ __html: description['content'] }}
      />
    </div>
  );
}

export default DescriptionCard;
